<template>
  <TypeAhead
    v-model="data"
    :id="idInput"
    :srcImgLoading="srcImgLoading"
    :classes="classes"
    :placeholder="placeholder"
    :src="urlGetAutocomplete"
    :getResponse="getResponse"
    :selectFirst="selectFirst"
    :limit="parseInt(limit)"
    :queryParamName="queryParamName"
    :minChars="parseInt(minChars)"
    :delayTime="parseInt(delayTime)"
    :onHit="onHit"
    :highlighting="highlighting"
    :render="render"
    :fetch="fetch"
    :clean="cleanDistrict"
  ></TypeAhead>
</template>
<script>
import axios from "axios";
//import TypeAhead from '../templatesComponents/ElementTypeaheadTemplate'
import TypeAhead from "../templatesComponents/VueSaxTypeAheadTemplate";

// VUEX ESTADO GLOBAL
import { mapState, mapMutations } from "vuex";

// const DEFAULT_TOKEN = "b5abb242-39a3-4179-a6c3-8eaf4269ea85";

export default {
  components: {
    TypeAhead,
  },
  data() {
    return {
      data: "",
      access_token: process.env.VUE_APP_TOKEN_APIS,
      urlGetAutocomplete: "",
      selectFirst: true,
      srcImgLoading: "@/assets/images/loading-two.gif",
      limit: 10,
      queryParamName: ":search",
      minChars: 2,
      delayTime: 0,
      placeholder: "Distrito ejm: SAN ISIDRO",
      idInput: "inputDistrito",
      classes: "typeahead searchDistrito",
    };
  },
  created() {
    this.urlGetAutocomplete =
      process.env.VUE_APP_ADMINLEVEL3 + "&key=" + this.access_token;
  },
  mounted() {
    let app = this;
    if (app.checkLogin()) {
      const tokenData = JSON.parse(window.localStorage.getItem("geodir_Token"));
      app.access_token = tokenData.data.access_token;
      app.urlGetAutocomplete =
        process.env.VUE_APP_ADMINLEVEL3 + "&key=" + app.access_token;
    }

    this.$store.watch(this.$store.getters.isLoggedIn, (n) => {
      if (!n) {
        app.access_token = process.env.VUE_APP_TOKEN_APIS;
      }
    });
  },
  computed: {
    ...mapState(["map"]),
  },
  methods: {
    ...mapMutations(["store_setUbigeo"]),

    checkLogin() {
      return this.$store.state.isLoggedIn;
    },
    getResponse: function (response) {
      return response.data;
    },

    onHit: function (item, vue, index, event) {
      if (item) {
        event.preventDefault();

        this.store_setUbigeo(item.locality_id);

        let layerMarker = this.$store.getters.layerMarkerSearcher;
        //let polygonSearcher = this.$store.getters.layerPolygonSearcher;

        if (layerMarker) {
          this.map.removeLayer(layerMarker);
          //this.map.removeLayer(polygonSearcher);
        }
        function styleUbigeo() {
          return {
            fillColor: "transparent",
            color: "transparent",
          };
        }
        var json = JSON.parse(item.bbox);
        let newResult = new L.GeoJSON(json, {
          style: styleUbigeo,
        });

        // agregar marcador
        this.map.addLayer(newResult);
        this.map.flyToBounds(newResult.getBounds(), {
          maxZoom: 16,
        });

        // agregar polygon
        //const parsedGeoJson = JSON.parse(item.geojson);
        //var polygon = L.geoJSON(parsedGeoJson).addTo(this.map);

        // agregar capas al store
        this.$store.commit("SET_LAYER_MARKER", newResult);
        //this.$store.commit("SET_GEOJSON_MARKER", polygon);

        vue.query = item.name;
        //Si ejecuto el cambiar a otro se pierde el efecto de seleccionar
        this.$emit("selectDistrito");
      }
    },

    _centerMapOfDistrit() {},

    highlighting: function (item, vue) {
      let value = "";
      if (typeof item === "object") {
        value = item.name;
      } else {
        value = item;
      }
      return value
        .toString()
        .replace(vue.query.toUpperCase(), `<b>${vue.query.toUpperCase()}</b>`);
    },

    render: function (items, vue) {
      //let newItem = [vue.query, ...items];
      let newItem = [...items];
      return newItem;
    },

    fetch: function (url) {
      return axios.get(url);
    },

    cleanDistrict: function () {
      this.$emit("cleanDistrictEmittion");
    },
  },
};
</script>
<style>
#inputDistrito {
  padding-right: 30px;
}

.searchDistrito {
  font-size: 14px;
}
</style>
